import React from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../../../../Dumbo';
import DeviationThumbOverlayDefault from '../../../legos/DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../../../legos/DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../../../legos/ThumbOverlayBackground';
import ThumbLink from '../../../legos/ThumbLink';
import s from './MobileThumbContent.scss';
var MobileThumbContent = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, responsive = _a.responsive, className = _a.className;
    return (React.createElement(ThumbLink, { deviation: deviation, width: width, height: height, wrapperClassName: classnames(s['root'], className) },
        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive, "aria-hidden": "true" }),
        React.createElement(ThumbOverlayBackground, { deviation: deviation, className: s['underlay'], showDefaultHover: true }),
        React.createElement(DeviationThumbOverlayDefault, { deviation: deviation, width: width, height: height, className: s['cover'] }),
        React.createElement(DeviationThumbMiddleContent, { deviation: deviation, thumbWidth: width, thumbHeight: height, className: s['middle'] })));
};
MobileThumbContent.displayName = 'MobileThumbContent';
export default MobileThumbContent;
//# sourceMappingURL=MobileThumbContent.js.map